import { InvitationStatus, WaterfallMode } from './static';

export interface PermissionsDocument {
  id: string;
  roles: Roles;
}

/** Mapping of all users with their role in the organization. */
export interface Roles {
  [memberId: string]: UserRole;
}

/** Roles a user can have in an organization. */
export type UserRole = 'superAdmin' | 'admin' | 'member';

/** Permissions related to an organization on a document. */
export interface DocPermissionsDocument {
  id: string;
  ownerId: string;
  isAdmin: boolean;
  canCreate: boolean;
  canRead: boolean;
  canUpdate: boolean;
  canDelete: boolean;
}

/** Factory function to create organization related permissions. */
export function createPermissions(params: Partial<PermissionsDocument>): PermissionsDocument {
  return {
    id: params.id || '',
    roles: params.roles || {},
    ...params
  };
}

/** Factory function to create organization permissions on a document. */
export function createDocPermissions(params: Partial<DocPermissionsDocument> = {}): DocPermissionsDocument {
  return {
    id: params.id || '',
    ownerId: params.ownerId || '',
    isAdmin: true,
    canCreate: true,
    canRead: true,
    canUpdate: true,
    canDelete: true,
    ...params
  };
}

export type WaterfallCredits = Record<WaterfallMode, number>;

export function createWaterfallCredits(params: Partial<WaterfallCredits> = {}): WaterfallCredits {
  return {
    dsm: 0,
    simulation: 0,
    default: 0,
    ...params
  };
}

export interface WaterfallCreditsRequest {
  id: string;
  mode: WaterfallMode;
  credits: number;
  message?: string;
  createdAt: Date;
  status: InvitationStatus;
}

export function createWaterfallCreditsRequest(params: Partial<WaterfallCreditsRequest> = {}): WaterfallCreditsRequest {
  return {
    id: params.id || '',
    mode: params.mode || 'default',
    credits: params.credits || 0,
    message: params.message || '',
    createdAt: params.createdAt || new Date(),
    status: params.status || 'pending',
  };
}

export interface Permissions extends PermissionsDocument {
  docPermissions?: DocPermissionsDocument[];
}